module.exports = __webpack_public_path__ + "static/media/my-activities-un.125b0186.svg";